import { makeStyles, Theme } from '@material-ui/core'
import { createStyles } from '@material-ui/core/styles'

const drawerWidthDeskTop = '19%'
const drawerWidthTab = 260

const itemSliderActive = {
  '& > .itemSliderActive': {
    position: 'absolute',
    left: 0,
    width: '6px',
    height: '24px',
    borderRadius: '0px 4px 4px 0px',
  },
}

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    drawer: {
      width: drawerWidthTab,
      flexShrink: 0,
      display: 'none',
      [theme.breakpoints.up('md')]: {
        display: 'block',
      },

      [theme.breakpoints.up('lg')]: {
        width: drawerWidthDeskTop,
      },
    },
    container: {
      position: 'relative',
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'space-between',
      height: '100%',
    },
    toolbar: {
      padding: '28px 34px',
      display: 'flex',
      alignItems: 'center',
    },
    logoImg: {
      display: 'none',
      [theme.breakpoints.up('md')]: {
        width: 100,
        height: 100,
        display: 'block',
      },
    },
    toolbarlg: {
      cursor: 'pointer',
      margin: ' 2px 32px 22px 32px',
      [theme.breakpoints.down('sm')]: {
        display: 'block',
        padding: '5px 0 10px 0',
      },
    },
    toolbarlgIcon: {
      display: 'flex',
      background: '#FFF',
      borderRadius: '30px',
      width: '100%',
      height: '44px',
      margin: 'auto',
      fontSize: theme.variables.fontSizeLg,
      alignItems: 'center',
      justifyContent: 'center',

      '& > div': {
        // lineHeight: '44px',
        marginLeft: '5px',
      },
      '& > img': {
        width: '20px',
        height: '20px',
      },
    },
    drawerPaper: {
      width: '100%',

      [theme.breakpoints.up('sm')]: {
        width: '375px',
      },
      '&::-webkit-scrollbar': {
        display: 'none',
      },
      /* Hide scrollbar for IE, Edge and Firefox */
      msOverflowStyle: 'none' /* IE and Edge */,
      scrollbarWidth: 'none' /* Firefox */,
      [theme.breakpoints.up('md')]: {
        width: '260px',
      },

      [theme.breakpoints.up('lg')]: {
        width: drawerWidthDeskTop,
      },

      backgroundColor: '#153C7B',
      overflowY: 'auto',
    },
    listItem: {
      textDecoration: 'none',
      opacity: 0.6,
      alignItems: 'center',
      display: 'flex',
      padding: '9px 34px',
      ...itemSliderActive,
      '&:hover': {
        opacity: 1,
      },
    },
    listItemFirstChild: {
      marginTop: '-6px',
    },
    listItemChild: {
      padding: '4px 34px',
    },
    listItemParnet: {
      justifyContent: 'space-between',
      alignItems: 'center',
      opacity: 0.6,
      display: 'flex',
      padding: '9px 34px',
      '& svg path': {
        fill: '#fff',
      },
      ...itemSliderActive,
      '& > .listItemParnetBox': {
        display: 'flex',
        alignItems: 'center',
      },
      '&:hover': {
        opacity: 1,
      },
    },
    isShowMenuItem: {
      display: 'none',
    },
    itemIcon: {
      display: 'flex',
      alignItems: 'center',
      color: '#BED1F6',

      '& > .spaceIcon': {
        width: '32px',
      },
    },
    itemText: {
      ...theme.typography.subtitle1,
      color: '#FFFFFF',
      lineHeight: '33px',
      marginLeft: '10px',
      alignItems: 'center',
      whiteSpace: 'nowrap',
      overflow: 'hidden',
      textOverflow: 'ellipsis',
      fontSize: theme.variables.fontSizeLg,
      fontWeight: theme.variables.fontWeight600,
      [theme.breakpoints.down('md')]: {
        fontSize: theme.variables.fontSizeSm,
        fontWeight: theme.variables.fontWeight500,
      },

      '&.mrLt1': {
        marginLeft: 1,
      },
    },
    itemTextChild: {
      fontSize: theme.variables.fontSize18,
      fontWeight: theme.variables.fontWeight600,
      [theme.breakpoints.down('md')]: {
        fontSize: theme.variables.fontSizeSm,
        fontWeight: theme.variables.fontWeight500,
      },
    },
    itemActive: {
      opacity: 1,
      color: '#FFFFFF',
      textDecoration: 'initial',
      ...itemSliderActive,
      '& .itemSliderActive': {
        background: '#fff',
      },
      '& > .listItemParnetBox': {
        display: 'flex',
        ...itemSliderActive,
        '& .itemSliderActive': {
          background: '#fff',
        },
        alignItems: 'center',
      },
    },
    languageButton: {
      background: 'white',
      fontSize: theme.variables.fontSizeSm,
      color: '#153C7B',
      borderRadius: '8px',
      paddingLeft: '12px',
      paddingTop: '8px',
      marginBottom: '8px',
      marginLeft: '15px',
      paddingBottom: '8px',
      width: 'auto',
      height: '40px',
      '& .MuiSelect-select.MuiSelect-select': {
        paddingRight: '32px',
        background: 'transparent',
      },
      '& .MuiSelect-icon': {
        top: 'auto',
        color: '#A1B1CA',
      },
    },
    displayControl: {
      [theme.breakpoints.up('md')]: {
        display: 'none',
      },
      [theme.breakpoints.down('md')]: {
        fontSize: theme.variables.fontSizeMd,
        width: '150px',
      },
    },
    divider: {
      background: '#57729E',
      width: 'calc(100% - 68px)',
      margin: '12px auto',
    },
    menuFooter: {
      padding: '24px 24px 24px 34px',

      '& > .menuFooterTxt': {
        color: '#FFFFFF',
        fontSize: theme.variables.fontSizeSm,
        [theme.breakpoints.down('md')]: {
          fontSize: theme.variables.fontSizeXs,
        },
      },
    },
    footerImg: {
      width: '30px',
      height: '30px',
      margin: '2px 0 0 8px',

      [theme.breakpoints.down('md')]: {
        width: '25px',
        height: '25px',
      },
    },

    appBar: {
      zIndex: 1400,
      height: '64px',
      boxShadow: 'none',
      backgroundColor: '#153C7B',

      [theme.breakpoints.up('md')]: {
        width: 'calc(100% - 260px)',
        marginLeft: '260px',
      },

      [theme.breakpoints.up('lg')]: {
        width: '81%',
        marginLeft: '19%',
        boxShadow: '0px 4px 16px rgba(38, 100, 223, 0.05)',
        backgroundColor: '#FFFFFF',
      },
    },
    menuButton: {
      position: 'absolute',
      color: '#ffff',
      marginRight: theme.spacing(2),
      [theme.breakpoints.up('md')]: {
        display: 'none',
      },
    },
    headerTopLg: {
      margin: 'auto',
      display: 'none',
      [theme.breakpoints.down('sm')]: {
        width: '150px',
        display: 'block',
        margin: '0 auto',
      },
    },
  }),
)

export default useStyles
